import React, {Component} from 'react'
import './styles.css'

import logo from '../../assets/logo.svg'

class Navbar extends Component {
  render() {
    const {about, onAboutClicked} = this.props
    const aboutIcon = about ? 'fa-arrow-circle-o-left' : 'fa-question-circle-o'
    return (
      <div className="navbar">
        <div className="navbar-logo-wrapper">
          <img src={logo} className="navbar-logo" alt="logo" />
        </div>
        <div className="navbar-controls">
          <div className="navbar-control" onClick={onAboutClicked}>
            <i className={`fa ${aboutIcon}`} />
          </div>
        </div>
      </div>
    )
  }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js